import React from 'react'

export interface GrowthFiguresProps {
  period: string
  data: number | null
  isAvailable: boolean
}

export const GrowthFigures: React.FC<GrowthFiguresProps> = ({ period, data, isAvailable }) => {
  let typeOfChange: 'positive' | 'negative' | '' = ''
  const hasValidData = data !== null
  const isDataAvailable = !hasValidData ? false : isAvailable

  switch (Math.sign(data || 0)) {
    case 1:
      typeOfChange = 'positive'
      break
    case -1:
      typeOfChange = 'negative'
      break
    default:
      typeOfChange = ''
  }

  const formatValue = () => {
    if (isDataAvailable && hasValidData) {
      return (typeOfChange === 'positive' ? '+' : '') + data?.toFixed(1)
    }
    return '-.-'
  }

  return (
    <div className={`growth-change-container ${isDataAvailable ? '' : 'unavailable'}`}>
      <p className="growth-change">% CHANGE</p>
      <p className="growth-change period">{period}</p>
      <p className={`growth-change-figure ${isDataAvailable ? typeOfChange : 'unavailable'}`}>{formatValue()}</p>
    </div>
  )
}
